import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getAuthErrorMessage } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardHeader, CardContent, CardTitle } from '../components/ui/card';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login, loginWithGoogle } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const signedInUser = await login(email, password);
      if (signedInUser && !signedInUser.emailVerified && signedInUser.providerData[0]?.providerId === 'password') {
        navigate('/verify-email', { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    } catch (err) {
      setError(getAuthErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setError('');
    setLoading(true);
    try {
      await loginWithGoogle();
      navigate('/', { replace: true });
    } catch (err) {
      setError(getAuthErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface px-4 py-10">
      <Card className="w-full max-w-md">
        <CardHeader className="pb-4 text-center">
          <p className="font-display text-3xl tracking-wider text-brand-sky">MATADEL</p>
          <CardTitle className="mt-2 text-center text-2xl">Accedi</CardTitle>
        </CardHeader>
        <CardContent>
        {error && (
          <div className="mb-4 rounded-btn border border-loss/60 bg-loss/15 px-3 py-2 text-sm text-red-100">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="login-email">Email</Label>
            <Input
              id="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="login-password">Password</Label>
            <Input
              id="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            />
          </div>
          <Button
            type="submit"
            className="mt-2 w-full"
            disabled={loading}
          >
            {loading ? 'Accesso in corso...' : 'Accedi'}
          </Button>
        </form>
        <div className="my-5 flex items-center gap-3">
          <div className="h-px flex-1 bg-surface-muted" />
          <span className="text-xs uppercase tracking-wide text-brand-ice/70">oppure</span>
          <div className="h-px flex-1 bg-surface-muted" />
        </div>
        <Button
          className="w-full"
          variant="outline"
          onClick={handleGoogleLogin}
          disabled={loading}
        >
          <span className="mr-2 font-bold text-brand-sky">G</span>
          Accedi con Google
        </Button>
        <p className="mt-4 text-center text-sm text-brand-ice/80">
          Non hai un account?{' '}
          <RouterLink to="/register" className="font-medium text-brand-sky underline-offset-4 hover:underline">
            Registrati
          </RouterLink>
        </p>
        </CardContent>
      </Card>
    </div>
  );
}
